(function () {
  // Locale-independent: keyed by Shopify product ID, generated from the
  // custom.variation_value metafield (primary/English locale) so it works
  // regardless of the translated color name shown on the storefront.
  var PRODUCT_COLOR_MAP = {
    '5421622296620': '#FFFFFF',
    '5421622362156': '#DFD2C5',
    '5421622624300': '#626262',
    '5421623476268': '#FFFFFF',
    '5421623509036': '#DFD2C5',
    '5421623869484': '#626262',
    '5421624066092': '#FFFFFF',
    '5421624131628': '#DFD2C5',
    '5421624393772': '#626262',
    '5425156620332': '#FFFFFF',
    '5425156653100': '#DFD2C5',
    '5425156882476': '#626262',
    '5425156915244': '#FFFFFF',
    '5425156948012': '#DFD2C5',
    '5425157177388': '#626262',
    '5425157472300': '#DFD2C5',
    '5425157570604': '#B5D3C0',
    '5425157767212': '#626262',
    '5425157963820': '#FFFFFF',
    '5425157996588': '#DFD2C5',
    '5425158291500': '#626262',
    '5441652850732': '#FFFFFF',
    '5441653145644': '#9A5545',
    '6811407188012': '#E8BC6A',
    '6811407286316': '#BCA68F',
    '6811407351852': '#E8BC6A',
    '6811407482924': '#E8BC6A',
    '6811407581228': '#BCA68F',
    '6811407777836': '#BCA68F',
    '6811407843372': '#E8BC6A',
    '6811407908908': '#BCA68F',
    '6811408039980': '#E8BC6A',
    '6811408171052': '#BCA68F',
    '6811408433196': '#E8BC6A',
    '6811408564268': '#BCA68F',
    '6836069793836': '#6C4A35',
    '6836069859372': '#E8BC6A',
    '6912578322476': '#87BC8D',
    '6912578388012': '#BCA68F',
    '6912578584620': '#DFD2C5',
    '6912578748460': '#87BC8D',
    '6912578813996': '#E8BC6A',
    '6981874286636': '#FFFFFF',
    '6981874516012': '#E8BC6A',
    '6983827685420': '#A8BF82',
    '6983828504620': '#626262',
    '6983828766764': '#BCA68F',
    '6983829323820': '#B9A5A7',
    '8340298432849': '#87BC8D',
    '8340298531153': '#FFFFFF',
    '8340298760529': '#626262',
    '8340298858833': '#9A5545',
    '8340298924369': '#626262',
    '8340299186513': '#87BC8D',
    '8639976767825': '#DFD2C5',
    '8639976833361': '#E8BC6A',
    '8639976964433': '#9A5545',
    '8639977029969': '#FFFFFF',
    '8639977193809': '#BCA68F',
    '8639977390417': '#626262',
    '9033538175313': '#BCA68F',
    '9033538765137': '#E70037',
    '9033539780945': '#E8BC6A',
    '9033540239697': '#BCA68F',
    '9033540305233': '#87BC8D',
    '9033540501841': '#E70037',
    '9033540731217': '#FFFFFF',
    '9033540927825': '#FFFFFF',
    '9033541058897': '#FFFFFF',
    '9033541255505': '#9A5545',
    '9064492433745': '#FFFFFF',
    '9486896791889': '#E8BC6A',
    '9703955661137': '#6C4A35',
    '9704011137361': '#A8BF82',
    '9793165656401': '#626262',
    '9793165787473': '#9A5545',
    '9796511105361': '#626262',
    '9938033344849': '#E8BC6A',
    '9940538655057': '#87BC8D',
    '9940549861713': '#E70037',
    '9940597375313': '#9A5545',
    '9940659175761': '#FFFFFF',
    '9940677460305': '#626262',
    '9940699742545': '#DFD2C5',
    '9941822898513': '#626262',
    '9941827846481': '#E70037',
    '9941878341969': '#FFFFFF',
    '9941908062545': '#626262',
    '9941921923409': '#9A5545',
    '9941936046417': '#B5D3C0',
    '9942343516497': '#E70037',
    '9942351741265': '#626262',
    '9942370648401': '#BCA68F',
    '9942396830033': '#87BC8D',
    '9942407872849': '#626262',
    '9942433956177': '#FFFFFF',
    '9942441886033': '#626262',
    '9942478782801': '#FFFFFF',
    '9942573056337': '#626262',
    '9942600122705': '#FFFFFF',
    '9942613393745': '#87BC8D',
    '9942646882641': '#E70037',
    '9942664216913': '#626262',
    '9942707994961': '#87BC8D',
    '9942747480401': '#9A5545',
    '9942776447313': '#BCA68F',
    '9942784999761': '#E8BC6A',
    '9942791979345': '#626262',
    '9942801580369': '#87BC8D',
    '9943039541585': '#9A5545',
    '9943248044369': '#E70037',
    '9943251910993': '#626262',
    '9943274717521': '#BCA68F',
    '9944902369617': '#BCA68F',
    '9944923504977': '#626262',
    '9944926617937': '#E70037',
    '9944937234769': '#626262',
    '9944947491153': '#DFD2C5',
    '9944951750993': '#626262',
    '9944957321553': '#FFFFFF',
    '9944959942993': '#E70037',
    '9945087508817': '#E70037',
    '9945099829585': '#626262',
    '9953189134673': '#6C4A35',
    '9953193558353': '#A8BF82',
    '9953195589969': '#B5D3C0',
    '9953197490513': '#626262',
    '9953257587025': '#A8BF82',
    '9953303167313': '#626262',
    '9953312768337': '#DFD2C5',
    '9953321943377': '#B5D3C0',
    '9953401930065': '#FFFFFF',
    '9953712144721': '#DFD2C5',
    '9953718042961': '#BCA68F',
    '9953767391569': '#DFD2C5',
    '9953774436689': '#BCA68F',
    '9953915797841': '#626262',
    '9953937785169': '#9A5545',
    '9953993458001': '#9A5545',
    '9954010562897': '#E70037',
    '9954058731857': '#626262',
    '9955383673169': '#BCA68F',
    '9955387015505': '#9A5545',
    '9955414606161': '#626262',
    '9955436462417': '#9A5545',
    '9955762110801': '#BCA68F',
    '9955788423505': '#FFFFFF',
    '9955793174865': '#626262',
    '9955825484113': '#BCA68F',
    '9955903570257': '#9A5545',
    '9955990831441': '#626262',
    '9956027203921': '#B5D3C0',
    '9956036116817': '#B9A5A7',
    '9956093165905': '#E8BC6A',
    '9956095525201': '#87BC8D',
    '9956098015569': '#FFFFFF',
    '9956206805329': '#B9A5A7',
    '9956215685457': '#87BC8D',
    '9956294623569': '#FFFFFF',
    '9956310810961': '#958183',
    '9956356391249': '#B9A5A7',
    '9956410130769': '#E8BC6A',
    '9956414980433': '#626262',
    '9956418519377': '#DFD2C5',
    '9956473340241': '#E8BC6A',
    '9958016254289': '#DFD2C5',
    '9958058295633': '#9A5545',
    '9958102204753': '#958183',
    '9958116032849': '#FFFFFF',
    '9958383550801': '#FFFFFF',
    '9958617317713': '#BCA68F',
    '9958797181265': '#626262',
    '9958827655505': '#87BC8D',
    '9958899777873': '#87BC8D',
    '9958904824145': '#BCA68F',
    '9958916358481': '#9A5545',
    '9958987825489': '#626262',
    '9961161523537': '#DFD2C5',
    '9961170338129': '#A8BF82',
    '9961173582161': '#E8BC6A',
    '9961259336017': '#DFD2C5',
    '9961262186833': '#BCA68F',
    '9961290432849': '#626262',
    '9961298035025': '#FFFFFF',
    '9961469247825': '#DFD2C5',
    '9961471312209': '#BCA68F',
    '9961478226257': '#FFFFFF',
    '9961480847697': '#626262',
    '9968532291921': '#DFD2C5',
    '10558727061841': '#DFD2C5',
    '10558772937041': '#E8BC6A',
    '10558903124305': '#DFD2C5',
    '10558913151313': '#BCA68F',
    '10674279219537': '#4C2300',
    '10674299863377': '#CAB788',
    '10674304319825': '#4C2300',
    '10679232725329': '#373D04',
    '10679382540625': '#373D04',
    '10679458955601': '#4C2300',
    '10684742926673': '#373D04',
    '10685130899793': '#ACD0DE',
    '10685207314769': '#ACD0DE',
    '10685209510225': '#E3676A',
    '10685218423121': '#4C2300',
    '10685229564241': '#CAB788',
    '10685240836433': '#CAB788',
    '10685248667985': '#4C2300',
    '10685271933265': '#CAB788',
    '10685276488017': '#4C2300',
    '10685280682321': '#4C2300',
    '10685290053969': '#4C2300',
    '10692310860113': '#ACD0DE',
    '10692318331217': '#373D04',
    '10692326293841': '#FFFFFF',
    '10692402676049': '#FFFFFF',
    '10692418339153': '#4C2300',
    '10692442194257': '#CAB788',
    '10694372262225': '#373D04',
    '10694392643921': '#CAB788',
    '10694401950033': '#4C2300',
    '10694407815505': '#373D04',
    '10694450315601': '#CAB788',
    '10694462636369': '#FFFFFF',
    '10694469517649': '#4C2300',
    '10699054874961': '#E3676A',
    '10699064344913': '#4C2300',
    '10699065622865': '#373D04',
    '10699102912849': '#373D04',
    '10699114545489': '#4C2300',
    '10699134337361': '#E3676A',
    '10699154489681': '#CAB788',
    '10699182408017': '#ACD0DE',
    '10699191124305': '#373D04',
    '10699195547985': '#FFFFFF',
    '10699218026833': '#ACD0DE',
    '10699236966737': '#CAB788',
    '10699245453649': '#E3676A',
    '10699256594769': '#4C2300',
    '10704239133009': '#4C2300',
    '10704283795793': '#E3676A',
    '10704295493969': '#ACD0DE',
    '10704310370641': '#CAB788',
    '10704313385297': '#373D04',
    '10704320921937': '#E3676A',
    '10704325673297': '#ACD0DE',
    '10704327737681': '#373D04',
    '10704335962449': '#ACD0DE',
    '10704357163345': '#CAB788',
    '10704360571217': '#FFFFFF',
    '10704364962129': '#373D04',
    '10704380166481': '#CAB788',
    '10704390324561': '#E3676A',
    '10704394486097': '#4C2300',
    '10704396648785': '#ACD0DE',
    '10704399368529': '#373D04',
    '10704412279121': '#CAB788',
    '10704418373969': '#ACD0DE',
    '10704431808849': '#373D04',
    '10704638574929': '#FFFFFF',
    '10704646242641': '#4C2300',
    '10704648995153': '#373D04',
    '10704653451601': '#ACD0DE',
    '10704683729233': '#FFFFFF',
    '10704701686097': '#CAB788',
    '10704973398353': '#4C2300',
    '10704977494353': '#E3676A',
    '10704980246865': '#373D04',
    '10704983327057': '#CAB788',
    '10704984539473': '#E3676A',
    '10704988471633': '#CAB788',
    '10704992502097': '#373D04',
    '10704995647825': '#626262',
    '10705003118929': '#CAB788',
    '10705013604689': '#4C2300',
    '10705016193361': '#626262',
    '10705027826001': '#373D04',
    '10705040736593': '#4C2300',
    '10705044963665': '#CAB788',
    '10705076846929': '#E3676A',
    '10705085432145': '#CAB788',
    '10705089069393': '#373D04',
    '10705104109905': '#4C2300',
    '10705113907537': '#E3676A',
    '10705117774161': '#ACD0DE',
    '10705124196689': '#CAB788',
    '10705140285777': '#4C2300',
    '10705143890257': '#373D04',
    '10705153786193': '#CAB788',
    '10705167417681': '#ACD0DE',
    '10705173250385': '#4C2300',
    '10705185309009': '#CAB788',
    '10705200611665': '#4C2300',
    '10705203069265': '#4C2300',
    '10705209459025': '#373D04',
    '10705220305233': '#CAB788',
    '10705306943825': '#373D04'
  };

  // Fallback for products not yet in PRODUCT_COLOR_MAP above (relies on the
  // displayed color name matching one of these English keys).
  var COLOR_MAP = {
    'beige': '#CAB788',
    'blush pink': '#E3676A',
    'cacao': '#4C2300',
    'charcoal': '#626262',
    'cream': '#DFD2C5',
    'deep olive': '#373D04',
    'dusty lavender': '#958183',
    'dusty levander': '#958183',
    'dusty rose': '#B9A5A7',
    'light blue': '#ACD0DE',
    'moss green': '#A8BF82',
    'mustard': '#E8BC6A',
    'rosy brown': '#BCA68F',
    'sage green': '#B5D3C0',
    'terracotta': '#9A5545',
    'viva magenta': '#E70037',
    'white': '#FFFFFF',
    'matcha green': '#87BC8D',
    'mocha brown': '#6C4A35'
  };

  var SKIP_NAMES = ['green gingham', 'mocha gingham'];

  function normalize(name) {
    return (name || '').trim().toLowerCase();
  }

  function applySolidSwatches() {
    document.querySelectorAll('.combined-color-swatch').forEach(function (el) {
      var name = normalize(el.getAttribute('data-color-name'));

      if (SKIP_NAMES.indexOf(name) !== -1) {
        return;
      }

      var productId = el.getAttribute('data-color-product-id');
      var hex = (productId && PRODUCT_COLOR_MAP[productId]) || COLOR_MAP[name];
      if (!hex) return;
      el.style.backgroundImage = 'none';
      el.style.backgroundColor = hex;
      el.classList.add('combined-color-swatch--solid');
    });
  }

  applySolidSwatches();

  var observer = new MutationObserver(applySolidSwatches);
  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', applySolidSwatches);
})();
